import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <section className="relative pt-24 min-h-[520px] flex items-center bg-slate-900 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_6a1e7ecf576a12c19392e6adbdebcc19_290839f6.jpg"
          alt="City to City Moving Company team — professional movers Southern California"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-slate-900/40"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
        <div className="flex items-center gap-2 text-orange-400 text-sm font-semibold mb-5">
          <Link to="/" className="hover:text-orange-300 transition-colors">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white">About Us</span>
        </div>
        <div className="max-w-2xl">
          <span className="inline-block bg-orange-500/20 text-orange-300 text-xs font-bold px-4 py-2 rounded-full mb-5 border border-orange-500/30">
            Family-Owned · Founded 2004 · Southern California
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-5">
            Southern California&apos;s Most{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-400">
              Trusted Moving Team
            </span>
          </h1>
          <p className="text-slate-300 text-lg leading-relaxed mb-8">
            We&apos;re not just movers — we&apos;re your neighbors. Since 2004, City to City Moving Company has helped thousands of Southern California families and businesses move with confidence, care, and zero stress.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="tel:7606257767"
              className="flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-7 py-3.5 rounded-xl font-bold hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap">
              <i className="ri-phone-fill text-lg"></i>Talk to Our Team
            </a>
            <Link to="/services"
              className="flex items-center gap-2 bg-white/10 border border-white/20 text-white px-7 py-3.5 rounded-xl font-semibold hover:bg-white/20 transition-all whitespace-nowrap">
              <i className="ri-grid-line text-lg"></i>View Our Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
